import React from "react";
import { AlertOctagon } from "lucide-react";

export const StatsCard = ({ icon: Icon, value, label, color, bgColor, oosCount }) => (
  <div 
    className="bg-white rounded-lg border border-slate-200 p-3 hover:shadow-md transition-shadow"
    data-testid={`stats-${label.toLowerCase().replace(/\s+/g, '-')}`}
  >
    <div className="flex items-center gap-2 mb-2">
      <div 
        className="w-8 h-8 rounded-md flex items-center justify-center shrink-0"
        style={{ backgroundColor: bgColor }}
      >
        <Icon className="w-4 h-4" style={{ color }} />
      </div>
      <div className="text-xs text-slate-500 font-medium truncate">{label}</div>
    </div>
    <div className="flex items-end justify-between">
      <div className="text-2xl font-bold text-slate-900">{value}</div>
      {oosCount !== undefined && oosCount > 0 && (
        <div className="flex items-center gap-1 text-xs text-red-500 font-medium bg-red-50 px-1.5 py-0.5 rounded">
          <AlertOctagon className="w-3 h-3" />
          {oosCount} OOS
        </div>
      )}
    </div>
  </div>
);

export const StatusDot = ({ status, label }) => {
  const isOk = status === "ok";
  return (
    <div className="status-indicator">
      <div 
        className={`status-indicator-dot ${isOk ? '' : 'status-dot'}`}
        style={{ backgroundColor: isOk ? "#34C759" : "#FF3B30" }}
      />
      <span className="status-indicator-label">{label}</span>
    </div>
  );
};
